import React from 'react';
import styles from './Theme.module.scss';
import NumericInput from 'component/atom/forms/input/number-input/NumericInput';
import Container from 'component/atom/container/Container';
import { useFormikContext } from 'formik';
const ThemeScale = ({}) => {
  const { values, handleChange, setFieldValue, errors, touched } =
    useFormikContext();

  const data = [
    {
      title: 'Temperature',
      subTitle:
        'Controls randomness. Lowering the temperature means that the model will produce more repetitive and deterministic responses. Increasing the temperature will result in more unexpected or creative responses.',
      min: 0,
      max: 1,
      value: values.temperature,
      name: 'temperature',
    },
    {
      title: 'Nucleus Sampling Factor',
      subTitle: 'For balanced output',
      min: 0,
      max: 1,
      value: values.nucleusSamplingFactor,
      name: 'nucleusSamplingFactor',
    },
    {
      title: 'Frequency Penalty',
      subTitle:
        'Reduce the chance of repeating any token that has appeared in the text at all so far. This increases the likelihood of introducing new topics in a response.',
      min: 0,
      max: 2,
      value: values.frequencyPenalty,
      name: 'frequencyPenalty',
    },
    {
      title: 'Presence Penalty',
      subTitle:
        'Reduce the chance of repeating any token that has appeared in the text at all so far. This increases the likelihood of introducing new topics in a response.',
      min: 0,
      max: 2,
      value: values.presencePenalty,
      name: 'presencePenalty',
    },
    {
      title: 'Max Token Response',
      subTitle:
        'Defines the maximum number of tokens (words, punctuation, and spaces) the chatbot can generate in a single response. Adjusting this helps control response length.',
      min: 0,
      max: 1000,
      value: values.maxTokenResponse,
      name: 'maxTokenResponse',
    },
  ];

  return (
    <Container className={styles.cont}>
      {data?.map((item, index) => {
        return (
          <div className={styles.cards}>
            <div
              className={styles.card}
              style={{ borderBottom: index == data?.length - 1 ? 'none' : '' }}
              key={index}
            >
              <div className={styles.title}>
                <h4>{item.title}</h4>
                <p>{item.subTitle}</p>
              </div>
              <NumericInput
                min={item.min}
                max={item.max}
                name={item.name}
                onChange={handleChange}
                value={item.value}
                style={{
                  width: '100px',
                }}
              />
            </div>
            <p className='error-message'>{errors?.[item.name]}</p>
          </div>
        );
      })}
    </Container>
  );
};

export default ThemeScale;
